import { styled } from 'stitches.config'
import { Text } from 'components/Text'
import { Stack } from 'components/Stack'

export const NeverAgainRoot = styled('section', {
  backgroundColor: '$accent-white',
  color: '$accent-black',
  px: '$2',
  paddingTop: '42px',
  paddingBottom: '42px',

  '@bp2': {
    px: '$15',
  },
})

export const Flex = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
})

export const Content = styled('div', {
  textAlign: 'center',
})

export const ButtonWrapper = styled('div', {})

export const Header = styled('h2', {
  fontSize: '$h3',
  letterSpacing: '$h3',
  lineHeight: '$h3',

  '@bp2': {
    fontSize: '$h1',
    letterSpacing: '$h1',
    lineHeight: '$h1',
  },
})

export const Description = styled(Text, {
  width: '100%',
})

export const CopyContainer = styled(Stack, {
  width: '100%',
  maxWidth: '440px',
  '@bp2': {
    maxWidth: '980px',
  },
})
